import React from 'react';
import { NavLink } from 'react-router-dom';
import { UilCreateDashboard, UilCircle, UilShield } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const getBorrowerMenuItems = (basePath, toggleCollapsed, topMenu) => {
  const { t } = useTranslation();
  const { borrowerId } = useSelector((state) => state.auth);
  return [
    {
      key: 'starter',
      label: (
        <NavLink onClick={toggleCollapsed} to={`${basePath}/pages/starter`}>
          {t('SMIP')} {t('Home')}
        </NavLink>
      ),
      icon: !topMenu && (
        <NavLink className="menuItem-iocn" to={`${basePath}/pages/starter`}>
          <UilCircle />
        </NavLink>
      ),
    },
    {
      key: 'Borrower Menu',
      label: t('Projects'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: '4',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/project/registration`}>
              {t('New Project')}
            </NavLink>
          ),
        },
        {
          key: '5',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/project/list`}>
              {t('Projects List')}
            </NavLink>
          ),
        },
      ],
    },
    // {
    //   key: 'Investment Menu',
    //   label: t('Investments'),
    //   icon: !topMenu && <UilCreateDashboard />,
    //   children: [
    //     {
    //       key: '7',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/investment/list`}>
    //           {t('Investments List')}
    //         </NavLink>
    //       ),
    //     },
    //   ],
    // },
    {
      key: 'Group Menu',
      label: t('Members'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: '8',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/members/list`}>
              {t('Members List')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'Wallet Menu',
      label: t('Wallet'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: '9',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/wallet/details`}>
              {t('Wallet')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'Validations Menu',
      label: t('Validations'),
      icon: !topMenu && <UilShield />,
      children: [
        {
          key: '10',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/validation/project/list`}>
              {t('Project Validations')}
            </NavLink>
          ),
        },
        {
          key: '11',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/validation/borrower/${borrowerId}`}>
              {t('Borrower Validations')}
            </NavLink>
          ),
        },
      ],
    },
    {
      key: 'Documents',
      label: t('Documents'),
      icon: !topMenu && <UilCreateDashboard />,
      children: [
        {
          key: 'My Documents',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/documents`}>
              {t('My Documents')}
            </NavLink>
          ),
        },
      ],
    },
  ];
};
